import { Component } from '@angular/core';
import { NavController ,NavParams } from 'ionic-angular';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
//import { WebService } from '../../../../../../providers/service/webservice';
//import { PHVERIFYCODE } from '../../../../../../providers/config/serviceurl';
import { AppState } from '../../../../../../app/app.global';
@Component({
	 selector: 'login-children-page',
  templateUrl: 'byphonemain.html'
})
export class VerifyByPhoneMainPage {

  timeCode:string;
  timeNumber:number = 60;
  telephone:string ="";
  constructor(public navCtrl: NavController,public global: AppState,public navParm :NavParams) {

  	this.timeCode = "获取验证码";
  	this.telephone = navParm.data.telephone;
  }
  getVerificationCode(){
  	 IntervalObservable.create(1000).subscribe(timeNumber => {
  	 	//let params= {"userId":this.userId,"telePhone":this.telePhone};
  	 	//this.webService.post(PHVERIFYCODE,params,'手机验证码').then(anyObj =>{});
	 	if(this.timeNumber > 0){
  	 		this.timeNumber--;
  	 		this.timeCode = this.timeNumber+"s";
  	 	}else{
  	 		this.timeCode = "重新获取验证码"
  	 	}
  	 });
  }
  verifyCode(){
  		//let params= {"userId":this.userId,"telePhone":this.telePhone,"verificationCode":this.verificationCode};
  	 	//this.webService.post(PHVERIFY,params,'手机验证').then(anyObj =>{});
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/password/types/byphone/main/byphonemain.ts